// Réutilise le transport cookie/CSRF installé par lib/http.js dans index.js.
const API = `${process.env.REACT_APP_BACKEND_URL ?? ''}/api/categories-depenses`;
export const EVENEMENT_CATEGORIES = 'categories-depenses-maj';

async function requete(url, options) {
  const r = await fetch(url, options);
  const data = await r.json().catch(() => null);
  if (!r.ok) {
    const detail = data?.detail;
    throw new Error(typeof detail === 'string' ? detail : 'Impossible de charger ou enregistrer les catégories.');
  }
  return data;
}

export function fetchCategoriesDepenses({ usage, toutes = false } = {}) {
  const q = new URLSearchParams();
  if (usage) q.set('usage', usage);
  if (toutes) q.set('inclure_inactives', 'true');
  return requete(`${API}?${q}`);
}

export async function enregistrerCategorieDepense(fiche) {
  const body = {
    libelle: fiche.libelle, groupe: fiche.groupe, ordre: Number(fiche.ordre),
    usages: fiche.usages, actif: fiche.actif,
    ...(fiche.id ? { version: fiche.version } : {}),
  };
  const resultat = await requete(fiche.id ? `${API}/${encodeURIComponent(fiche.id)}` : API, {
    method: fiche.id ? 'PUT' : 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  window.dispatchEvent(new Event(EVENEMENT_CATEGORIES));
  return resultat;
}
